import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { RawLocation } from 'vue-router'
import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'

interface Props {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'link' | 'action'
  size?: 'md' | 'sm'
  loading?: boolean
  disabled?: boolean
  icon?: string
  to?: RawLocation
  href?: string
  type?: 'button' | 'submit' | 'reset'
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UIButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { default: undefined },
    to: { default: undefined },
    href: { default: undefined },
    type: { default: 'button' },
    label: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: 'primary' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'link' | 'action', size: 'md' | 'sm', loading: boolean, disabled: boolean, icon: string, to: RawLocation, href: string, type: 'button' | 'submit' | 'reset', label: string };





const variantClasses = computed(() => {
  const variants: Record<string, string> = {
    primary: 'bg-juniper-600 border border-juniper-500 text-ink-400 hover:bg-juniper-500',
    secondary:
      'bg-ink-200 text-vanilla-400 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] hover:bg-ink-100 hover:text-vanilla-100',
    outline: 'bg-transparent border border-gray-11 text-gray-1 hover:border-gray-10',
    ghost: 'bg-transparent text-gray-3 hover:bg-gray-11 hover:text-gray-1',
    destructive: 'bg-cherry-600 text-ink-100 hover:bg-cherry-500',
    link: 'text-juniper-600 hover:underline p-0 h-auto border-none bg-transparent',
    action:
      'bg-ink-300 border-[0.5px] border-ink-50 text-vanilla-400 hover:bg-ink-200 hover:text-vanilla-100'
  }
  return variants[props.variant] || variants.primary
})

const sizeClasses = computed(() => {
  const sizes: Record<string, string> = {
    md: 'py-2 px-4 text-sm rounded-lg',
    sm: 'py-1 px-2.5 text-xs rounded-md'
  }
  if (props.variant === 'link') return ''
  return sizes[props.size] || sizes.md
})

const iconSize = computed(() => {
  return props.size === 'sm' ? 'x-small' : 'small'
})
const isExternal = computed(() => Boolean(props.href))
const isInternal = computed(() => Boolean(props.to) && !isExternal.value)
const isButton = computed(() => !isExternal.value && !isInternal.value)
const componentTag = computed(() => {
  if (isExternal.value) return 'a'
  if (isInternal.value) return 'nuxt-link'
  return 'button'
})
const showLoading = computed(() => isButton.value && props.loading)

return { __sfc: true,props, emit, variantClasses, sizeClasses, iconSize, isExternal, isInternal, isButton, componentTag, showLoading, ZIcon }
}

})